export const TYPES = {
  TagLinksDao: Symbol.for('TagLinksDao'),
  TagLinksRepository: Symbol.for('TagLinksRepository'),
  TagLinksUseCases: Symbol.for('TagLinksUseCases'),
};
